import { createEffect, Show, Suspense, type ParentProps } from "solid-js"
import { createStore } from "solid-js/store"
import { useLocation } from "@solidjs/router"
import { DebugBar } from "@/components/debug-bar"
import { TabsInfoPopup } from "@/components/help-button"
import { Titlebar, type TitlebarUpdate } from "@/components/titlebar"
import { usePlatform } from "@/context/platform"
import { setV2Toast, ToastRegion } from "@/utils/toast"
import { DatoxFactsheetShell } from "@/components/datox-factsheet-shell"
import { datoxAgentMode, datoxV2Design } from "@/datox/api"
import { DatoxV2Shell } from "@/components/datox-v2-shell"
import { v2ShellPath } from "@/datox/v2/routes"

export default function NewLayout(props: ParentProps) {
  const platform = usePlatform()
  const location = useLocation()
  const [state, setState] = createStore({ debugTools: true })

  createEffect(() => setV2Toast(true))

  const update: TitlebarUpdate = {
    version: () => {
      const state = platform.updater?.state()
      if (state?.status !== "ready") return
      return state.version
    },
    installing: () => platform.updater?.state().status === "installing",
    install: () => void platform.updater?.install(),
  }

  return (
    <div
      class="relative bg-v2-background-bg-deep flex-1 min-h-0 min-w-0 flex flex-col select-none [&_input]:select-text [&_textarea]:select-text [&_[contenteditable]]:select-text"
      style={{
        "padding-top": "env(safe-area-inset-top, 0px)",
        "padding-bottom": "env(safe-area-inset-bottom, 0px)",
      }}
    >
      <Show when={(location.pathname.replace(/\/$/, "") === "/chats" ? datoxAgentMode() : datoxV2Design()) && v2ShellPath(location.pathname)} fallback={<>
      <Show when={datoxAgentMode()} fallback={<>
      <Titlebar
        update={update}
        debugTools={
          import.meta.env.DEV
            ? { visible: state.debugTools, toggle: () => setState("debugTools", (value) => !value) }
            : undefined
        }
      />
      <main class="flex-1 min-h-0 min-w-0 overflow-x-hidden flex flex-col items-start contain-strict">
        <Suspense>
          {props.children}
        </Suspense>
      </main>
      </>}><Suspense><DatoxFactsheetShell>{props.children}</DatoxFactsheetShell></Suspense></Show>
      <Show when={!datoxAgentMode()}>{import.meta.env.DEV && state.debugTools && <DebugBar inline />}<TabsInfoPopup /></Show>
      </>}><DatoxV2Shell update={update}>{props.children}</DatoxV2Shell></Show>
      <ToastRegion v2 />
    </div>
  )
}
